// @ts-nocheck
import * as addPanel from '@/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['design_section_label_explore_textinput'],
      sections: [addPanel.sections.getSections().developer.textInputSection],
    };
  },
};
